import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { ENV_VARIABLES } from 'src/common/constants';

export function StagingBanner() {
  const [isDismissed, setIsDismissed] = useState(false);

  if (ENV_VARIABLES.APP_ENVIRONMENT !== 'staging' || isDismissed) {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-center gap-2 bg-amber-400 px-4 py-1 text-sm font-semibold text-black">
      <span>STAGING</span>
      {ENV_VARIABLES.GIT_REF && (
        <span className="font-mono text-xs font-normal">
          {ENV_VARIABLES.GIT_REF}
          {ENV_VARIABLES.GIT_COMMIT &&
            `@${ENV_VARIABLES.GIT_COMMIT.slice(0, 7)}`}
        </span>
      )}
      <button
        aria-label="Dismiss staging banner"
        className="ml-2 flex items-center"
        onClick={() => setIsDismissed(true)}
        type="button"
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
}
